import React, { useEffect, useState } from "react";
import api from "../../utils/api";
import CommentInput from "./CommentInput";
import CommentItem from "./CommentItem";
import "./comment.css"; // ? CSS file

export default function VideoComments({ videoId, currentUser }) {
  const [comments, setComments] = useState([]);
  const [type, setType] = useState("top");
  const [loading, setLoading] = useState(false);

  const loadComments = async () => {
    try {
      setLoading(true);
      const res = await api.get("/client/videoComment/getComments", {
        params: {
          userId: currentUser?._id,
          videoId,
          commentType: type,
        },
      });

      setComments(res.data?.videoComment || []);
    } catch {
      setComments([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (videoId) loadComments();
  }, [videoId, type, currentUser]);

  return (
    <div className="video-comments-wrapper">

      {/* HEADER */}
      <div className="comment-header-top">
        <h3>Comments</h3>
        <span className="comment-count">
          {comments.length}
        </span>
      </div>

      {/* SORT TABS */}
      <div className="comment-sort-tabs">
        {["top", "newest", "mostLiked"].map((t) => (
          <button
            key={t}
            onClick={() => setType(t)}
            className={`sort-tab ${type === t ? "active" : ""}`}
          >
            {t}
          </button>
        ))}
      </div>

      {/* INPUT */}
      <div className="comment-input-section">
        {currentUser ? (
          <CommentInput
            videoId={videoId}
            user={currentUser}
            onSuccess={loadComments}
          />
        ) : (
          <div className="comment-login-box">
            Login to comment
          </div>
        )}
      </div>

      {/* LIST */}
      <div className="comment-list">
        {loading ? (
          <p className="comment-loading">Loading...</p>
        ) : comments.length === 0 ? (
          <p className="comment-empty">No comments yet</p>
        ) : (
          comments.map((c) => (
            <CommentItem
              key={c._id}
              data={c}
              currentUser={currentUser}
              onAction={loadComments}
            />
          ))
        )}
      </div>

    </div>
  );
}
